import { LocalStyles } from "@paperbits/common/styles";

export class SubscriptionsModel {
    /**
     * Widget local styles.
     */
    public styles: LocalStyles = {};

}
